module.exports = __webpack_public_path__ + "img/logo@2x.4ca2ed55.png";